/* @flow */

import * as React from 'react';

import {
  mapNotificationComponentClass,
  isTakeOverNotification,
  isModalNotification,
  getNotificationId,
  getNotificationComponentClass,
} from 'src/shared/app/notification/util/notificationUtil';
import TakeOver from 'src/shared/app/base/component/template/component/TakeOver';
import BaseNotification from 'src/shared/app/base/component/template/component/BaseNotification';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import Transition, { EXITED } from 'react-transition-group/Transition';
import { notificationTransitionDuration } from 'src/shared/app/notification/constant/notificationConstants';
import { useSelector } from 'react-redux';
import { getNotificationQueueOfBundleType } from 'src/shared/app/notification/selector/uiNotificationSelectors';

type WrapperProps = {
  notification: Notification<>,
  children: React.Node,
};

const RootWrapper = ({ children, notification }: WrapperProps) => {
  const id = getNotificationId(notification);
  if (isModalNotification(notification)) {
    return <BaseNotification key={id}>{children}</BaseNotification>;
  }
  if (isTakeOverNotification(notification)) {
    return <TakeOver key={id}>{children}</TakeOver>;
  }
  return <React.Fragment key={id}>{children}</React.Fragment>;
};
type Props = {
  notification: Notification<>,
  isVisible: boolean,
};

export default function NotificationContainerItem({
  notification,
  isVisible,
}: Props): React.Node {
  const bundleNotifications = useSelector(
    getNotificationQueueOfBundleType(notification),
  );
  const compClass = getNotificationComponentClass(notification);
  const Component = mapNotificationComponentClass(compClass);
  const nodeRef = React.useRef(null);

  return (
    <Transition
      nodeRef={nodeRef}
      in={isVisible}
      timeout={notificationTransitionDuration}
    >
      {(state) => (
        <>
          {state !== EXITED && (
            <div ref={nodeRef}>
              <RootWrapper notification={notification}>
                <Component
                  notification={notification}
                  bundleNotifications={bundleNotifications}
                />
              </RootWrapper>
            </div>
          )}
        </>
      )}
    </Transition>
  );
}
